import $ from 'jquery';
window.$ = window.jQuery = $;
// import 'animate.css';
